// The home page's two ambient glows, for any page that wants the same light.
// Fixed behind the content (z-0), so the page's own content sits at z-10.
//
// Gradients, not `blur()`: a 120px blur on a fixed 600px circle is a huge
// offscreen layer, and with the feed's own effects it ran iOS Safari out of
// graphics memory — the page loaded but painted black. A gradient fading to
// nothing looks the same.
//
// Both sit in one viewport-sized, clipped box: on their own, a 960px circle
// hanging off a 390px phone made the page wider than the screen, and iOS
// opened it zoomed in and loose sideways.

export function AmbientGlow() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div
        className="absolute -left-[25%] -top-[35%] h-[960px] w-[960px]"
        style={{ background: "radial-gradient(closest-side, color-mix(in srgb, var(--primary) 10%, transparent), transparent)" }}
      />
      <div
        className="absolute -bottom-[35%] -right-[25%] h-[860px] w-[860px]"
        style={{ background: "radial-gradient(closest-side, rgba(28, 57, 142, 0.2), transparent)" }}
      />
    </div>
  );
}
